import { Grid, Paper, TextField } from "@mui/material";
import { BANQUET_DECORATION, BANQUET_DJ, ORDER_FROM, ORDER_FROM_ID } from "../../constants/ConfigConstant";
import { useEffect, useState } from "react";
import ExtrasOrderUI from "../global/js/ExtrasOrderUI";
import { BillStatus, isEmpty, OfferType, printDebugLog } from "../../constants/Constants";

const ExtraBanquetForm = ({
    totalDaysStay,
    billInformation,
    setBillInformation,
    configDecoration,
    configDj,
    extrasOrderMap,
    setExtraOrderMap,
    billPayInfo,
    setBillPayInfo,
    setSnpComponent
    , keyMapInformation, setKeyMapInformation, disabledOperation
}) => {


    useEffect(() => {
        console.info("skand ExtraBanquetForm", extrasOrderMap);
    }, [extrasOrderMap])

    useEffect(() => {
        console.info("skand billPayInfo", billPayInfo);
    }, [billPayInfo])

    const GROUP_KEYS = [BANQUET_DECORATION, BANQUET_DJ, "Other"];
    //id: "",  predefinedPrice: 0,
    const [itemDetails, setItemDetails] = useState([]);

    const handleSetExtraOrderOption = (grpKey) => {
        printDebugLog("handleSetExtraOrderOption", grpKey);
        if (isEmpty(grpKey)) {
            setItemDetails([]);
            return;
        }
        if (BANQUET_DECORATION === grpKey) {
            const updatedDetails = [
                ...Array.from(configDecoration.entries()).map(([key, value]) => ({
                    id: key,
                    predefinedPrice: Number(value ?? 0),
                })),
                {
                    id: "Other",
                    predefinedPrice: "",
                },
            ];

            setItemDetails(updatedDetails);
        } else if (BANQUET_DJ === grpKey) {
            const updatedDetails = [
                ...Array.from(configDj.entries()).map(([key, value]) => ({
                    id: key,
                    predefinedPrice: Number(value ?? 0),
                })),
                {
                    id: "Other",
                    predefinedPrice: "",
                },
            ];

            setItemDetails(updatedDetails);
        }
    }

    const doTotal = (mTotalExtraPrice) => {
        printDebugLog("doTotal", mTotalExtraPrice, billPayInfo);
        let mCgstAmt = 0.0;
        let mSgstAmt = 0.0;
        let mRoundOff = 0.0;
        let mSubTotal = 0.0;
        let mFinalPrice = 0.0;
        const parseCgst = Number(billPayInfo?.cgst ?? 0) / 100;
        const parseSgst = Number(billPayInfo?.sgst ?? 0) / 100;
        const parseOfferDenom = Number(billPayInfo?.takenDenom ?? OfferType.No_Offer);
        const parseOfferAmt = Number(billPayInfo?.takenOffrAmt ?? 0);

        const restoNExtraTotalPrice = mTotalExtraPrice + Number(billPayInfo?.totalRestaurantBillPrice ?? 0);

        mSubTotal = Number(billPayInfo?.totalRoomPrice ?? 0) + Number(billPayInfo?.totalBanquetPrice ?? 0);

        mSubTotal = (mSubTotal * totalDaysStay) + restoNExtraTotalPrice;
        mFinalPrice = mSubTotal;
        if (parseOfferDenom === OfferType.Flat) {
            mFinalPrice -= parseOfferAmt;
        } else if (parseOfferDenom === OfferType.Percentage) {
            mFinalPrice -= (mFinalPrice * parseOfferAmt / 100);
        }
        if (billPayInfo?.gstAllowed ?? true) {
            mCgstAmt = (mFinalPrice * parseCgst);
            mSgstAmt = (mFinalPrice * parseSgst);
        }
        mFinalPrice = mFinalPrice + mCgstAmt + mSgstAmt;
        mRoundOff = mFinalPrice.toFixed() - mFinalPrice;
        mFinalPrice = mFinalPrice + mRoundOff;
        const pendingAmt = billPayInfo?.paymentInitiated ?? false ? billPayInfo?.pendingAmt ?? 0 : mFinalPrice;

        setBillPayInfo(prev => ({
            ...prev,
            totalExtraPrice: mTotalExtraPrice,
            cgstAmt: mCgstAmt,
            sgstAmt: mSgstAmt,
            roundOff: mRoundOff,
            totalPrice: mSubTotal,
            finalPrice: mFinalPrice,
            pendingAmt: pendingAmt,
        }));
    };

    const updateExtraPrice = (oldExtraItemPrice, newExtraItemPrice) => {
        if (totalDaysStay === 0) {
            setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: true,
                snackBarMsg: "Please save the Date Selection Form",
            }))
            return;
        }
        const isEdit = !isEmpty(oldExtraItemPrice) && Number(oldExtraItemPrice) > 0;
        printDebugLog("updateExtraPrice", oldExtraItemPrice, newExtraItemPrice, isEdit, billPayInfo);
        const mTotalExtraPrice = Number(billPayInfo?.totalExtraPrice ?? 0) + Number(newExtraItemPrice ?? 0) - Number(oldExtraItemPrice ?? 0);
        doTotal(mTotalExtraPrice);
        setSnpComponent(prev => ({
            ...prev,
            snackBarOpen: true,
            snackBarMsg: `${isEdit ? "Updated" : "Created"} Successfully`,
        }))
    }

    const deleteExtraPrice = (extraPrice) => {
        printDebugLog("deleteExtraPrice", extraPrice, billPayInfo);
        if (totalDaysStay === 0) {
            setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: true,
                snackBarMsg: "Please save the Date Selection Form",
            }))
            return;
        }
        const mTotalExtraPrice = Number(billPayInfo?.totalExtraPrice ?? 0) - Number(extraPrice ?? 0);
        doTotal(mTotalExtraPrice);
        setSnpComponent(prev => ({
            ...prev,
            snackBarOpen: true,
            snackBarMsg: `Deleted Successfully`,
        }))
    }

    const checkPaidStatus = () => {
        if (billPayInfo?.paymentInitiated ?? false) {
            setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: true,
                snackBarMsg: `Paid bill can't be deleted`,
            }))
            return true;
        }
        if (disabledOperation) {
            setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: true,
                snackBarMsg: "Cancelled bill cannot be deleted",
            }));
            return true;
        }
        return false;
    }

    return (
        <Grid container spacing={2}
            sx={{
                padding: 2,
            }}>
            <Grid item xs={12}>
                <Paper
                    elevation={0}
                    sx={{
                        borderRadius: 2,
                        p: 2,
                        backgroundColor: "#fffadf",
                    }}>
                    <Grid container spacing={2}>
                        <ExtrasOrderUI
                            groupKeys={GROUP_KEYS}
                            itemDetails={itemDetails}
                            extrasOrderMap={extrasOrderMap}
                            setExtraOrderMap={setExtraOrderMap}
                            handleSetExtraOrderOption={handleSetExtraOrderOption}
                            updateExtraPrice={updateExtraPrice}
                            deleteExtraPrice={deleteExtraPrice}
                            checkPaidStatus={checkPaidStatus}
                        />
                        {/* <Grid item md={4} xs={12} sm={5}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DateTimePicker label="Actual Check In :"
                                    readOnly={billInformation?.billStatus === BillStatus.BILLSETTLED}
                                    value={dayjs(keyMapInformation.get(ACTUAL_CHECK_IN) ?? "", 'DD/MM/YYYY HH:mm:ss')}
                                    onChange={(e) => {
                                        const cInDate = e?.format("DD/MM/YYYY HH:mm:ss");
                                        setKeyMapInformation(prev => {
                                            const newMap = new Map(prev);
                                            newMap.set(ACTUAL_CHECK_IN, cInDate);
                                            return newMap;
                                        })
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid> */}
                        <Grid item md={4} xs={12} sm={5}>
                            <TextField
                                variant="filled"
                                size="small"
                                disabled={disabledOperation}
                                label="Order Via"
                                onChange={(e) => setKeyMapInformation(prev => {
                                    const newMap = new Map(prev);
                                    newMap.set(ORDER_FROM, e.target.value);
                                    return newMap;
                                })}
                                value={keyMapInformation.get(ORDER_FROM) ?? ""}
                            />
                        </Grid>
                        <Grid item md={4} xs={12} sm={5}>
                            <TextField
                                variant="filled"
                                size="small"
                                disabled={disabledOperation}
                                label="Order Via Id"
                                onChange={(e) => setKeyMapInformation(prev => {
                                    const newMap = new Map(prev);
                                    newMap.set(ORDER_FROM_ID, e.target.value);
                                    return newMap;
                                })}
                                value={keyMapInformation.get(ORDER_FROM_ID) ?? ""}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={6}>
                            <TextField
                                id="remarks"
                                label="Enter Remarks/FeedBack"
                                name="remarks"
                                multiline={true}
                                rows={3}
                                disabled={billInformation?.billStatus === BillStatus.BILLSETTLED}
                                variant="filled"
                                size="small"
                                defaultValue={billInformation?.remarks ?? ""}
                                onChange={(e) => setBillInformation(prev => ({
                                    ...prev,
                                    remarks: e.target.value
                                }))}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={6} sm={6}>
                            <TextField
                                id="reason"
                                label="Enter Reason"
                                name="reason"
                                multiline={true}
                                rows={3}
                                disabled={billInformation?.billStatus === BillStatus.BILLSETTLED}
                                variant="filled"
                                size="small"
                                defaultValue={billInformation?.reason ?? ""}
                                onChange={(e) => setBillInformation(prev => ({
                                    ...prev,
                                    reason: e.target.value
                                }))}
                                fullWidth
                            />
                        </Grid>
                    </Grid>

                </Paper>
            </Grid>
        </Grid>
    )
};

export { ExtraBanquetForm };